import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";

interface Notification {
  id: string;
  email: string;
  Subject: string;
  Message: string;
  Read: boolean;
  date: string;
}

interface UseGetNotificationReturn {
  notification?: Notification | null;
  loading: boolean;
  refetch: () => Promise<any>;
}

interface GetNotificationResponse {
  getNotification?: Notification | null;
  comGetNotification?: Notification | null;
}

/**
 * Custom hook to fetch a single notification by id.
 */
export function useGetNotification(
  notificationId?: string,
): UseGetNotificationReturn {
  const { data, loading, refetch } = useQuery<GetNotificationResponse>(
    queries.getNotification,
    {
      variables: {
        notificationId: notificationId || "",
      },
      skip: !notificationId,
    },
  );

  return {
    notification: data?.getNotification || data?.comGetNotification || null,
    loading,
    refetch,
  };
}
